export default "__VITE_ASSET__D4zq3L5b__"